import { SignupUserModal } from 'components/modals/SignupUserModal'
import { MainPage } from 'components/templates/MainPage'
import { Suspense, useState } from 'react'
import { UserList } from './UserList'
export const AdminPage = () => {
  const [isNewUserModalOpen, setIsNewUserModalOpen] = useState(false)
  return (
    <MainPage>
      <div
        className={
          'rounded-lg bg-white p-6 shadow-[0_2px_4px_rgba(0,0,0,0.08)]'
        }
      >
        <div className={'mb-4 flex justify-end'}>
          <button
            type="button"
            className="rounded bg-[#01695C] px-4 py-2 text-sm text-white hover:opacity-90"
            onClick={() => setIsNewUserModalOpen(true)}
          >
            ユーザー追加
          </button>
        </div>
        <Suspense fallback={<></>}>
          <UserList />
        </Suspense>
        {isNewUserModalOpen && (
          <SignupUserModal onClose={() => setIsNewUserModalOpen(false)} />
        )}
      </div>
    </MainPage>
  )
}
